import api from "../config/api";

// OPCAO:
// 1 - Pagamento Online;
// 2 - Débito Automático;
// 3 - DAM
// 4 - Todos
export const getBanks = async (opcao) => {
  let banks = []

  try{
    let banksResponse = await api.get("Bancos/Consultar?opcao=" + opcao)
    if (banksResponse.data.length > 0) {
      banks = banksResponse.data
    }
  } catch(error) {
    banks = "Erro ao carregar os Bancos."
  }

  return banks
}